var _style, _g, _circle, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanxiumCoinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0E101D;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fond"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 500,
    cy: 500,
    r: 500
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 587.3316,
    y1: 499.9986,
    x2: 719.9994,
    y2: 499.9986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C37F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE41EB"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 653.67,
    cy: 500,
    r: 66.33
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M552.5,793.85c-12.05,0-29.67-3.32-45.22-19.14l-2.69-2.73c-6.86-7.64-11.82-16.81-14.48-26.74l-0.17-0.72 c-0.32-1.64-0.65-3.25-1-4.83l-0.31-1.49c-23.98-105.62-101.2-162.5-167.86-172.49l-0.82-0.41l-2.43,0 c-0.67-0.07-1.73-0.23-3.37-0.56c-40.8-8.11-56.45-41.08-53.89-70.17c0.08-0.93,0.21-1.79,0.33-2.65l0.22-1.67 c0.06-0.49,0.12-0.98,0.21-1.48c0.14-0.79,0.32-1.6,0.5-2.39l0.11-0.49c0.24-1.11,0.48-2.2,0.77-3.29l0.34-1.14 c5.59-19.35,18.55-33.93,36.53-41.2c5.71-2.45,11.45-4.04,17.33-4.82c31.7-4.67,59.67-15.51,81.07-31.37 c47.05-34.54,80.7-88.49,92.3-148.01l0.35-1.32v-0.11c2.74-9.95,7.63-18.88,14.55-26.56c12.46-13.93,30.19-21.9,48.69-21.9 c32.15,0,52.12,21.01,60.16,40.67c8.06,19.69,8.61,48.66-14.03,70.92l-2.73,2.69c-7.51,6.74-16.49,11.65-26.22,14.33h-0.09 l-1.32,0.35c-1.58,0.31-4.72,0.96-4.72,0.96l-1.44,0.31c-66.78,15.16-140.06,63.11-165.31,138.08 c-5.34,15.86-7.16,27.85-2.42,44.67c5.77,20.5,14.33,38.46,25.53,53.56c34.53,47.05,88.45,80.68,147.97,92.29l0.35,0.1l0.16,0.02 l0.9,0.24h0.06c9.94,2.73,18.87,7.62,26.55,14.54c13.93,12.45,21.9,30.19,21.9,48.69c0.06,22.23-9.96,36.95-18.37,45.39 C587.89,786.6,570.4,793.85,552.5,793.85C552.5,793.85,552.5,793.85,552.5,793.85z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanxiumCoinLogo);
export default __webpack_public_path__ + "static/media/canxium-coin-logo.a2c20a4c08356a93efb0c4646c4c609d.svg";
export { ForwardRef as ReactComponent };